module.exports = __webpack_public_path__ + "static/media/a1.c8b8d613.pdf";